import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';

export const Card = styled('div')({
    padding: 24,
    backgroundColor: 'var(--light-main)',
    border: '1px solid var(--divider)',
    borderRadius: 8,
    boxShadow: 'none',
    '@media (max-width: 1024px)': {
        padding: 16,
    },
});

export const CardFooter = styled('div')({
    paddingTop: 24,
    '@media (max-width: 1024px)': {
        paddingTop: 16,
    },
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8,
    '@media (max-width: 700px)': {
        flexDirection: 'column',
        alignItems: 'flex-start',
        '& > div:first-of-type': {
            marginBottom: 16,
        },
    },
});

export const CardControls = styled('div', {
    shouldForwardProp: prop => prop !== 'columns',
})(({ columns = 1 }) => ({
    display: 'grid',
    gridGap: 6,
    gridTemplateColumns: `repeat(${columns}, 32px)`,
    '@media (max-width: 700px)': {
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        width: '100%',
        '& > span': {
            display: 'flex',
        },
    },
}));

export const CardIconButton = styled(IconButton)({
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: 8,
    width: 32,
    height: 32,
    padding: 2,
    '@media (max-width: 700px)': {
        width: '100%',
    },
    '& svg': {
        width: 18,
        height: 18,
        '& path': {
            fill: 'var(--text-secondary)',
        },
    },
    '&.Mui-disabled': {
        '& svg': {
            '& path': {
                fill: 'rgba(0, 0, 0, 0.26)',
            },
        },
    },
});

export const CardsGrid = styled('div')({
    display: 'grid',
    gridGap: 16,
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    '@media (max-width: 480px)': {
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    },
});

export const CardDivider = styled('div')({
    width: '100%',
    height: 1,
    backgroundColor: 'var(--divider)',
});
